/*  NPM  */
import { connect } from 'react-redux';

/*  Component  */
import JSX from '../Page';

const mapStateToProps = (state) => ({
    session: state.session,
    tenants: state.tenants
});

export default connect(mapStateToProps, null)(JSX);
